export enum ConfigurationTreeviewEnum {
  Projet = 0,
  Zone,
  TypeTir,
  Niveau,
  Annee,
  month,
  Aucun
}
